Monitoring.Views ||= {}

class Monitoring.Views.KeywordsCondition

	constructor: (conditions = {})->
    @conditions = conditions
    @setDefaultConditions()

  setDefaultConditions: ->
  	@conditions['primary_keywords'] = @conditions['primary_keywords'] || []
  	@conditions['secondary_keywords'] = @conditions['secondary_keywords'] || []
  	@conditions['excluded_keywords'] = @conditions['excluded_keywords'] || []
  	@conditions['primary_keywords_logic'] = @conditions['primary_keywords_logic'] || 'OR'
  	@conditions['secondary_keywords_logic'] = @conditions['secondary_keywords_logic'] || 'OR'
  	@conditions['excluded_keywords_logic'] = @conditions['excluded_keywords_logic'] || 'OR'


  get: (field)->
  	@conditions[field]

  set: (field, value) ->
    @conditions[field] = value
  	